module.exports = __webpack_public_path__ + "static/media/default_logo.a1822b6f.svg";